export const PAYMENT_STATUS_CONFIG: Record<
  string,
  { label: string; color: "default" | "warning" | "success" | "error" }
> = {
  __EMPTY__: {
    label: "Do zapłaty",
    color: "error",
  },

  Generated_x0020_Payment: {
    label: "Wygenerowano przelew",
    color: "default",
  },

  Partially_x0020_Paid: {
    label: "Częściowo zapłacono",
    color: "warning",
  },

  Paid: {
    label: "Zapłacono",
    color: "success",
  },
};